import { getEnvironment } from '@uipath/portal-shell-util';

import agov from '../envConfigs/agov.json';
import alp from '../envConfigs/alp.json';
import integrationTest from '../envConfigs/integration-test.json';
import k8s from '../envConfigs/k8s.json';
import local from '../envConfigs/local.json';
import localMsi from '../envConfigs/local-msi.json';
import msi from '../envConfigs/msi.json';
import pgov from '../envConfigs/pgov.json';
import prd from '../envConfigs/prd.json';
import sgov from '../envConfigs/sgov.json';
import stg from '../envConfigs/stg.json';
import { GlobalPropsInstanceResolver } from './globalProps/globalPropsInstanceResolver';

const envConfigs = {
    local,
    'local-msi': localMsi,
    alp,
    stg,
    prd,
    pgov,
    agov,
    sgov,
    msi,
    k8s,
    'integration-test': integrationTest,
};

export const isNonCloud = (env = getEnvironment()) => {
    return env === 'local'
        || env === 'integration-test'
        || env === 'local-msi'
        || env === 'k8s'
        || isMsiOrStandalone(env);
};

export const isLocal = (env = getEnvironment()) => {
    return env === 'local'
        || env === 'local-msi'
        || (isNonCloud(env) && GlobalPropsInstanceResolver.Instance?.devProperties?.mode === 'dev-cloud');
};

export const isMsi = (env = getEnvironment()) => {
    if (!shouldModeOverride(env)) {
        return false;
    }

    const mode = GlobalPropsInstanceResolver.Instance?.devProperties?.mode;
    const isEnvMsi = env?.includes('msi');
    return mode
        ? (isEnvMsi && ([ 'msi', 'auto', 'dev-msi' ].includes(mode)))
        : isEnvMsi;
};

export const isStandalone = (env = getEnvironment()) => {
    const mode = GlobalPropsInstanceResolver.Instance?.devProperties?.mode;
    if (mode === 'standalone') {
        return true;
    }
    return shouldModeOverride(env)
        ? (mode ? mode === 'dev-msi' : true)
        : false;
};

export const isMsiOrStandalone = (env = getEnvironment()) => {
    return isMsi(env) || isStandalone(env);
};

const shouldModeOverride = (env = getEnvironment()) => {
    return [ 'local', 'msi', 'local-msi' ].includes(env);
};

export function getEnvConfig(env = getEnvironment()) {
    return envConfigs[env] || {};
}

export function getEnvConfigField(fieldName: string, env = getEnvironment(), enableLocalStorageOverrides = false) {
    let localStorageValue;
    try {
        localStorageValue = enableLocalStorageOverrides ? JSON.parse(localStorage.getItem(`PORTAL_OVERRIDE_${fieldName}`) ?? '') : undefined;
    } catch (error) {
        localStorageValue = undefined;
    }
    const config = getEnvConfig(env);
    return localStorageValue || config[fieldName] || undefined;
}
